<template>
 <div>
  <div class="detailsTitle" >
      <h4>发票</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
           <el-form-item>
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
           <el-form-item label="应收发票:" prop="">
            <span class="red">{{tongji.totalPayable?tongji.totalPayable.toFixed(2):'0.00'}}元</span>
          </el-form-item>
          <el-form-item label="实收发票:" >
            <span class="red">{{tongji.taxMoney?tongji.taxMoney.toFixed(2):'0.00'}}元</span>
          </el-form-item>
          <el-form-item label="未收发票:" v-if="tongji.totalUnpaid>0">
            <span class="red">{{tongji.totalUnpaid?tongji.totalUnpaid.toFixed(2):'0.00'}}元</span>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
                <el-button type="text" size="mini" @click="lookFn(scope.row)">发票照片</el-button>
              </div>
            </template>
        </el-table-column>
         <el-table-column property="expenseType" width="110" label="费用科目" >
          <template scope="scope">
            {{[ "运费", "滞期费" ,"装卸费","其他"][scope.row.expenseType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="taxMoney" min-width="200"  :formatter="emptyFn" label="发票金额(元)"></el-table-column>
        <el-table-column prop="invoiceCompany" min-width="200"  :formatter="emptyFn" label="发票抬头"></el-table-column>
        <el-table-column prop="shipOwner" min-width="200"  :formatter="emptyFn" label="船方名称"></el-table-column>
         <el-table-column property="invoiceType" width="130" label="发票类型" >
          <template scope="scope">
            {{[ "增值税专用发票", "普通发票" ][scope.row.invoiceType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="invoiceCode" min-width="150"  :formatter="emptyFn" label="发票代码"></el-table-column>
        <el-table-column prop="invoiceNo" min-width="150"  :formatter="emptyFn" label="发票号"></el-table-column>
        <el-table-column prop="noTaxMoney" min-width="150"  :formatter="emptyFn" label="不含税金额(元)"></el-table-column>
        <el-table-column property="pricingMethod" width="110" label="税额(元)" >
          <template scope="scope"> {{scope.row.taxes.toFixed(2)}}</template>
        </el-table-column>
        <el-table-column prop="taxMoney" min-width="150"  :formatter="emptyFn" label="含税金额(元)"></el-table-column>
        <el-table-column prop="invoiceDate" min-width="150"  :formatter="dateFormat" label="开票日期"></el-table-column>
        <el-table-column prop="recvInvoice" min-width="150"  :formatter="dateFormat" label="收票日期"></el-table-column>
        <el-table-column prop="shipName" min-width="150"  :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="shipDateNo" min-width="150"  :formatter="emptyFn" label="航次号"></el-table-column>
        <el-table-column prop="remark" :show-overflow-tooltip="true"  min-width="200" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="800px" center>
      <span>
         <el-form :inline="true"  :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
              <el-form-item label="费用科目:" prop="expenseType">
                <el-select  v-model="addFrom.expenseType"    placeholder="请选择">
                  <el-option label="运费" :value="1" ></el-option>
                  <el-option label="滞期费" :value="2" ></el-option>
                  <el-option label="装卸费" :value="3" ></el-option>
                  <el-option label="其他" :value="4" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票抬头:"  prop="invoiceCompany" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.invoiceCompany"></el-input>
              </el-form-item>
              <el-form-item label="船方名称:"  prop="shipOwner" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.shipOwner"></el-input>
              </el-form-item>
              <el-form-item label="发票类型:" prop="invoiceType">
                <el-select  v-model="addFrom.invoiceType"    placeholder="请选择">
                  <el-option label="增值税专用发票" :value="1" ></el-option>
                  <el-option label="普通发票" :value="2" ></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="发票代码:"  prop="invoiceCode" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.invoiceCode"></el-input>
              </el-form-item>
               <el-form-item label="发票号:"  prop="invoiceNo" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.invoiceNo"></el-input>
              </el-form-item>
              <el-form-item label="不含税金额:" prop="noTaxMoney" class="jiage">
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="11" v-model="addFrom.noTaxMoney"  ></el-input><span class="danwei1">元</span>
              </el-form-item>
              <el-form-item label="税额:" prop="taxes" class="jiage">
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="11" v-model="addFrom.taxes"  ></el-input><span class="danwei1">元</span>
              </el-form-item>
              <el-form-item label="含税金额:" class="jiage" prop="taxMoney"  >
                <el-input  placeholder=""   class="disabled" :readonly="true" v-model="addFrom.taxMoney" ></el-input><span class="danwei">元</span>
              </el-form-item>
              <el-form-item label="开票日期:" prop="invoiceDate" >
                <el-date-picker
                    v-model="addFrom.invoiceDate"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    type="date"
                      placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="收票日期:" prop="recvInvoice" >
                <el-date-picker
                    v-model="addFrom.recvInvoice"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    type="date"
                      placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
              <el-form-item label="船舶名称:"  prop="shipName"  >
                <el-input  placeholder=""   class="disabled" :readonly="true" v-model="addFrom.shipName" ></el-input>
              </el-form-item>
              <el-form-item label="航次号:"  prop="shipDateNo"  >
                <el-input  placeholder=""   class="disabled" :readonly="true" v-model="addFrom.shipDateNo" ></el-input>
              </el-form-item>
              <el-form-item label="备注:" class="remark" prop="remark" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.remark"></el-input>
              </el-form-item>
              <div class="addressBox" v-if="dialogVisible">
                <h4 class="title">
                  <span ><i style="color:#F56C6C; margin-right:4px">*</i>发票照片</span>
                </h4>
                <div>
                    <div class="imgBox">
                      <uploadImgs :imgList.sync='imgList' :max=20 @remove='remove'></uploadImgs>
                  </div>
                </div>
              </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">保存</el-button>
        <el-button type="primary" v-if="isAdd" @click="saveFn('addFrom',1)">保存并继续</el-button>
      </span>
    </el-dialog>
     <!-- 发票照片 -->
    <el-dialog  title="发票照片"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"    :visible.sync="FKPZdialog" width="1000px" center>
      <span>
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>付款凭证</span>
            </h4>
            <div class="">
              <el-image
                v-for="(item,index) in zhanshiList" :src="item" :key="index"
                style="width: 290px; height: 200px ; margin-right: 30px;"
                :preview-src-list="getSrcList(index,zhanshiList)">
              </el-image>
          </div>
        </div>
      </span>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="FKPZdialog = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sShipInvoiceList, addOrUpdateInvoice, sShipInvoiceDelete, settlementFile } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    uploadImgs
  },
  data () {
    var id = this.$route.query.id
    let totalPayable = this.$route.query.totalPayable
    return {
      id: id,
      totalPayable: totalPayable,
      shipName: this.$route.query.shipName,
      shipDateNo: this.$route.query.shipDateNo,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dialogVisible: false,
      isAdd: true,
      tableList: [],
      searchFrom: {
        settlementId: id,
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      tongji: {},
      ids: [],
      loading: 'false',
      rules: {
        invoiceCompany: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        expenseType: [
          { required: true, message: '请选择费用科目', trigger: 'blur' }
        ],
        shipOwner: [
          { required: true, message: '请输入船方名称', trigger: 'blur' }
        ],
        invoiceCode: [
          { required: true, message: '请输入发票代码', trigger: 'blur' }
        ],
        invoiceNo: [
          { required: true, message: '请输入发票号', trigger: 'blur' }
        ],
        noTaxMoney: [
          { required: true, message: '请输入不含税金额', trigger: 'blur' }
        ],
        taxes: [
          { required: true, message: '请输入税额', trigger: 'blur' }
        ],
        invoiceDate: [
          { required: true, message: '请选择开票日期', trigger: 'blur' }
        ]

      },
      addFrom: {
      },
      imgList: [],
      zhanshiList: [],
      FKPZdialog: false,
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00KM070100', '00KM070200', '00KM070300', '00KM070400', '00KM070500',
        '00KM070600', '00KM070700', '00KM070800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 135) + 'px'
  },
  methods: {
    // 付款凭证
    lookFn (row) {
      this.zhanshiList = []
      settlementFile({ id: row.id, type: 3 }).then(res => {
        if (res.length > 0) {
          res.forEach(item => {
            this.zhanshiList.push(item.fileUrlOSS)
          })
          this.FKPZdialog = true
        } else {
          this.$alert('该结算下面没有滞期涵', '系统提示')
        }
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 导出
    exportFn () {
      let form = { settlementId: this.id }
      exportExcel(
        this.global.shipping + '/sShipInvoice/exportInvoiceList',
        form,
        '发票单据'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sShipInvoiceList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.tongji = res.map
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.addFrom = { settlementId: this.id, invoiceType: 1, shipName: this.shipName, shipDateNo: this.shipDateNo }
      this.dialogVisible = true
      this.isAdd = true
    },
    editFn (row) {
      this.addFrom = { ...row }
      this.imgList = []
      this.$set(this.addFrom, 'delFileIds', [])
      settlementFile({ id: row.id, type: 3 }).then(res => {
        if (res.length > 0) {
          res.forEach((item, index) => {
            this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
          })
        }
        this.dialogVisible = true
        this.isAdd = false
      })
    },
    // 删除图片
    remove (file) {
      if (file.id) {
        this.addFrom.delFileIds.push(file.id)
      }
    },
    saveFn (formName, flag) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imgList.length == 0) {
            this.$alert('请添加发票照片', '系统提示')
            return
          }
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify(this.addFrom))
          let arr = []
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          compressImages(arr, {
            width: 1000
          }).then(result => {
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.save1(imgfile, flag)
          })
        } else {
          return false
        }
      })
    },
    save1 (data, flag) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addOrUpdateInvoice(data).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        if (flag == 1) {
          this.$set(this.addFrom, 'invoiceNo', '')
          this.$set(this.addFrom, 'noTaxMoney', '')
          this.$set(this.addFrom, 'taxes', '')
          this.$set(this.addFrom, 'id', null)
          this.isAdd = true
          this.imgList = []
          this.getList(this.searchFrom)
        } else {
          this.dialogVisible = false
          this.getList(this.searchFrom)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipInvoiceDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = { }
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
      this.imgList = []
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  },
  watch: {
    addFrom: {
      handler (newName, oldName) {
        if ((this.addFrom.noTaxMoney || this.addFrom.noTaxMoney == 0) && (this.addFrom.taxes || this.addFrom.taxes == 0)) {
          this.$set(this.addFrom, 'taxMoney', toFixed(Number(this.addFrom.noTaxMoney) + Number(this.addFrom.taxes), 2))
        }
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  flex-direction:column;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}

.jiage{
  position: relative;
  .danwei1{
    position: absolute;
       left: 160px;
  }
}
/deep/.inpBox .el-input__inner{
 width: 180px;
}
</style>
